import { COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export async function getIncentiveCards() {
    const response = await axios.get(`${COMMISSIONS_ENDPOINT}/getAllIncentiveTypes`);
    
    return response?.data?.data.map(incentive => ({
        ...incentive, active: false, confirmed: false
    }))
}